import pharmacy from 'services/pharmacy';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { browserHistory } from 'App';

export default () => {
    const dispatch = useDispatch();
    const postOrderReminder = async (payload) => {
      try {
        const response = await pharmacy.post(`/patients/orders/reminders`, payload, { headers: { 'api-version': 'v2' } });
        return response.data;
      } catch (e) {
        if (e.response && e.response.data.readable_error_message) {
          dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
              msg: e.response.data.readable_error_message,
              newMessage: true,
              link: '',
              ctaText: '',
            },
          });
          browserHistory.push('/pharmacy/error');
        }
        throw e;
      }
    };

    const deleteOrderReminder = async (payload) => {
      try {
        const response = await pharmacy.delete(`/patients/orders/reminders/${payload}`);
        return response.data;
      } catch (e) {
        if (e.response && e.response.data.readable_error_message) {
          dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
              msg: e.response.data.readable_error_message,
              newMessage: true,
              link: '',
              ctaText: '',
            },
          });
          browserHistory.push('/pharmacy/error');
        }
        throw e;
      }
    }
  
    return [deleteOrderReminder, postOrderReminder];
  };